import React from "react";
import { Navigate } from "react-router-dom";
import SignIn from "../components/SignIn";
import { useAuth } from "../context/AuthContext";
import { LoadingScreen } from "../routes/ProtectedRoute";
import SignInSplit from "../components/SignInSplit";

const Login = () => {
  const { loading, isAuthenticated } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  // return <SignIn />;
  
  return <SignInSplit />;
};

export default Login;

